module.exports = __webpack_public_path__ + "img/logo-white.ed6e5336.png";